import { useEffect, useRef } from 'react'

const usePrevious = <T>(value: T): T => {
  // Store current value in ref
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current
}

export default usePrevious
